import { AccountStatusEnum, UserRole } from '@app/app.enum';
import { IAppRouteConfig } from '@app/app.routes';
import { IInjectedAppModuleProps } from '@app/providers/app-module.provider';
import { IMediaQueryMatch } from '@app/providers/media-query.provider';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { History } from 'history';
import { InjectedIntl } from 'react-intl';
import { RouteComponentProps } from 'react-router';
import * as models from './index';
import { IAxiosCancellation } from './index';
import { ISnackBarFeature } from './shared.models';

const accountService: AccountService = Injector.get(AccountService);

export interface IAppComponentProps extends RouteComponentProps, IInjectedAppModuleProps, IMediaQueryMatch {}

export interface IAppComponentState {
	// authentication: models.IAuthState;
	isAuthenticated?: boolean;
	status: AccountStatusEnum;
	userRole: UserRole;
	routes: IAppRouteConfig[];
	sidebarOpen: boolean;
}

export const initialAppState = (sidebarOpen?: boolean): IAppComponentState => {
	// TODO: find a better way of doing it. also we are just checking for existence of token. but
	// we also need to validate this token.
	const isAuthorized = accountService.IsAuthorized;
	const accountStatus = accountService.AccountStatus;

	return {
		// authentication: models.initialAuthState(isAuthorized),
		isAuthenticated: isAuthorized,
		status: accountStatus,
		userRole: UserRole.User,
		routes: [],
		sidebarOpen,
	};
};

export interface IAppReduxState {
	authentication?: IAppReduxAuthenticationState;
}

export interface IAppReduxAuthenticationState {
	isAuthenticated?: boolean;
	user?: models.IUser;
	apiKey?: string;
	status?: AccountStatusEnum;
}

export const initialAppReduxState = (): IAppReduxState => {
	const userData = accountService.getUserData();
	return {
		authentication: {
			isAuthenticated: false,
			user: userData ? userData.user : null,
			status: accountService.AccountStatus,
		},
	};
};

export interface IAccountAppViewProps extends IAxiosCancellation, ISnackBarFeature {
	classes: any;
	history: History<any>;
	intl: InjectedIntl;
	apps?: models.IAccountAppResponseVM[];
	accountStatus?: AccountStatusEnum;
	isPartnerAccount?: boolean;
}

export interface IPaginationToken {
	Current: number;
	Next?: number;
}



// WEBPACK FOOTER //
// ./src/models/app.models.ts